import React from 'react';
import Header from './Header';
import './Splash.scss';
import './Card.scss';
import Arrow from './Arrow';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCertificate, faLink, faHandPointer } from '@fortawesome/free-solid-svg-icons';
import validUrl from 'valid-url';

interface SplashProps {
  newLink :string
  toDashboard :() => void
  signUp :() => void
  logout :() => void
  showContact :() => void
  setNewLink :(e :React.ChangeEvent<HTMLInputElement>) => void
}

interface SplashState {
  invalidURL :boolean
  showAbout :boolean
  showPricing :boolean
}


class Splash extends React.Component<SplashProps, SplashState> {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLinkChange = this.handleLinkChange.bind(this);

    this.state= { invalidURL: false, showAbout: false, showPricing: false };
  }

  handleSubmit(e) {
    e.preventDefault();

    if(validUrl.isHttpUri(this.props.newLink) || validUrl.isHttpsUri(this.props.newLink)) {
      this.props.toDashboard();
    } else {
      this.setState({ invalidURL: true })
    }
  }

  handleLinkChange(e) {
    this.setState({ invalidURL: false });
    this.props.setNewLink(e);
  }

  logEvent(label) {
    try {
      window.gtag('event', label, {
        event_category: 'engagement',
        event_label: label
      })
    } catch {}
  }

  render() {
    return <><div className="pk-header"><div className="pk-menu">
    <a className="navbar-item" onClick={() => this.setState({ showAbout: true }, () => this.logEvent('viewedAbout'))}>About</a>
    <a className="navbar-item" onClick={() => this.setState({ showPricing: true }, () => this.logEvent('viewedPricing'))}>Pricing</a>
    <button className="navbar-item button" onClick={this.props.signUp}>Log in</button></div></div>
      <div className="pk-splash">
      <div className="pk-hero">
        <div className="columns">
            <div className="column">
              <h1 className="title is-1">Improve CTR with editable link previews.</h1>
            </div>

            <div className="column">
          <div className="pk-card-container column">
            <div className="pk-card">
                <div className="pk-editor facebook">
                <div className="pk-image-container"><img src="/img/curtains.jpg" /><div className="pk-your-image">Your eye-catching image goes here</div></div></div>
                <div className="pk-content">
                <p className="pk-card-title">Your engaging title goes here</p>
                <p className="pk-description">Your enticing description goes here</p>
                <p className="pk-destination">your.domain.com</p>
                </div>
            </div>
          </div>
          </div>
        </div>
        <div className="pk-paste-link">
          <label className="label">Get started today</label>
          <div className="field has-addons">
        <form onSubmit={this.handleSubmit}>
          <div className="control">
            <input className={`input is-large ${this.state.invalidURL && 'is-danger'}`} type="text" placeholder="Paste your link..."
              value={this.props.newLink} onChange={this.handleLinkChange} />
          </div>
          <div className="control">
            <button type="submit" className="button is-primary is-large">
              <FontAwesomeIcon icon={faArrowRight} />&nbsp;&nbsp;Edit preview
            </button>
          </div>
        </form>
      </div>
        {this.state.invalidURL && <p className="help is-danger">Please enter a valid URL</p>}
      </div>
    </div>

      <div className="pk-arrow-container-1">
          <Arrow />
      </div>

      <div className="pk-advanced">
          <div>
          <h1 className="title is-1">The most advanced link preview tool.</h1>

          <div className="columns">
            <div className="column"><span className="pk-upper">Customize</span> your link image with stylized text, a screenshot, an image from your site, or any other image.</div>
            <div className="column"><span className="pk-upper">Optimize</span> images for specific platforms (Facebook, Twitter, etc).</div>
            <div className="column"><span className="pk-upper">Analyze</span> results with GPDR compliant, ad-blocker immune click counts.</div>
          </div>
          <div className="columns">
            <div className="column"><span className="pk-upper">Experiment</span> by creating multiple link previews for the same content for A/B testing.</div>
            <div className="column"><span className="pk-upper">Tailor</span> your message to different audiences by editing link title and description.</div>
            <div className="column"><span className="pk-upper">Brand</span> your links with unlimited custom domains.</div>
          </div>
      </div></div>

    <div className="pk-arrow-container-2">
          <Arrow />
      </div>

      <div className="pk-free-tier">
        <h1 className="title is-1">
          Get started now for just $5.
        </h1>

        <ul>
            <li><FontAwesomeIcon icon={faArrowRight} /> $1.00 per 1,000 clicks, pay only for what you use</li>
            <li><FontAwesomeIcon icon={faArrowRight} /> Free after 100,000 clicks per month</li>
            <li><FontAwesomeIcon icon={faArrowRight} /> 5x less expensive than similar services</li>
        </ul>
      </div>

      <div className="pk-arrow-container-3">
          <Arrow />
      </div>

      <div className="pk-trusted">
        <div>
          <h1 className="title is-1">
            The most trusted link preview platform.
          </h1>

          <table>
            <tbody>
              <tr>
                <td><FontAwesomeIcon icon={faLink} /></td>
                <td>Hundreds of thousands of links created.</td>
              </tr>
              <tr>
                <td><FontAwesomeIcon icon={faHandPointer} /></td>
                <td>Hundreds of millions of clicks served.</td>
              </tr>
              <tr>
                <td><FontAwesomeIcon icon={faCertificate} /></td>
                <td>Satisfaction gauranteed.</td>
              </tr>
            </tbody>
          </table>
          </div>
      </div>
      <Footer showContact={this.props.showContact} />
      </div>

      <div className={`modal ${this.state.showPricing && 'is-active'}`}>
            <div className="modal-background" onClick={() => this.setState({showPricing: false})}></div>
              <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Pricing</p>
                <button className="delete" aria-label="close" onClick={() => this.setState({showPricing: false})}></button>
              </header>
              <section className="modal-card-body content">
                  <h5>Pay only for what you use</h5>
                  <ul>
                    <li>$1.00 per 1,000 clicks</li>
                    <li>$5 one-time setup fee</li>
                    <li>Cost is capped at $100 / month (no charge after 100,000 clicks / mo)</li>
                    <li>Payment helps reduce spam and fraud</li>
                    <li>Cancel anytime</li>
                  </ul>
                  <center><button className="button is-primary is-large" onClick={this.props.signUp}>Log in to get started</button></center>

              </section>
            </div>
          </div>

          <div className={`modal pk-about ${this.state.showAbout && 'is-active'}`}>
            <div className="modal-background" onClick={() => this.setState({ showAbout: false })}></div>
              <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">About</p>
                <button className="delete" aria-label="close" onClick={() => this.setState({showAbout: false})}></button>
              </header>
              <section className="modal-card-body content">
                <p>Peeklink was created by me, <a href="https://tonygarvan.dev" target="_blank">Anthony Garvan</a>.
                  I&apos;m a software developer based out of Chicago.</p>
                <p>Peeklink has been under development since early 2018, when I built it on a whim as a more fun way to share links on social media.
                  It took off a bit from there, getting a good reception from it&apos;s launch on <a href="https://www.producthunt.com/posts/peeklink"
                  target="_blank">Product Hunt</a> and soon seeing widespread use.
                  People from over 170 countries have used Peeklink to create hundrends of thousands of links and serve over 100 million clicks.
                </p>
                <p>I&apos;m always interested in hearing about your experience with Peeklink. If something's not working right, or you have ideas for how it could be improved,
                  please <a onClick={this.props.showContact}>reach out</a>.</p>

                <center><img src="/img/me.png" /></center>
              </section>
              </div>
          </div>
    </>
  }
}

export default Splash;
